import { render, staticRenderFns } from "./MemberLabelFormPane.vue?vue&type=template&id=5a01fdf1&scoped=true"
import script from "./MemberLabelFormPane.vue?vue&type=script&lang=js"
export * from "./MemberLabelFormPane.vue?vue&type=script&lang=js"
import style0 from "./MemberLabelFormPane.vue?vue&type=style&index=0&id=5a01fdf1&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a01fdf1",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/mall_vue_JOYE/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a01fdf1')) {
      api.createRecord('5a01fdf1', component.options)
    } else {
      api.reload('5a01fdf1', component.options)
    }
    module.hot.accept("./MemberLabelFormPane.vue?vue&type=template&id=5a01fdf1&scoped=true", function () {
      api.rerender('5a01fdf1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/member/member_label/MemberLabelFormPane.vue"
export default component.exports